import { createClient } from '@supabase/supabase-js';

// Environment variables with fallback to hardcoded values for development
export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://yqnuhxyxiyginnzvkxfm.supabase.co';
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlxbnVoeHl4aXlnaW5uenZreGZtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY0MTgwOTksImV4cCI6MjA2MTk5NDA5OX0.xGnEuimY0EodFNVDAhv8a5K0r1pMSdZi-_v67F2nEno';

// Validate required environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing required Supabase environment variables');
}

// Log for debugging (only in development)
if (import.meta.env.DEV) {
  console.log('Supabase Client Initialization:', {
    url: supabaseUrl,
    hasKey: !!supabaseAnonKey,
    usingEnvVars: !!import.meta.env.VITE_SUPABASE_URL
  });
}

// Create and export the Supabase client instance with auth configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
});